import { Component, OnInit, computed } from '@angular/core';
import { LayoutService } from '../service/app.layout.service';
import { Store } from '@ngrx/store';
import { logout } from '../../shared/state/auth/auth.actions';
import { ToastServiceService } from '../../shared/services/toast-service.service';
import { selectUser } from 'src/app/shared/state/auth/auth.selectors';
import { filter, take } from 'rxjs';
import { selectProfile } from 'src/app/shared/state/profile/profile.selectors';
import { ProfileInfoDto } from 'src/app/shared/interfaces/profile/profile';
import { AvatarService } from 'src/app/shared/services/utilities/avatar-service.service';
import { Router } from '@angular/router';
import { selectSubscription, selectHasValidSubscription } from 'src/app/shared/state/subscription/subscription.selectors';
import { SubscriptionStatusResponse } from 'src/app/shared/interfaces/stripe/stripe-interface';

@Component({
  selector: 'app-profilemenu',
  standalone: false,
  templateUrl: './app.profile-sidebar.component.html',
  styleUrls: ['./app.profile-sidebar.component.scss'],
})
export class AppProfileSidebarComponent implements OnInit {
  avatarBase64 = '';
  profile: ProfileInfoDto | null | undefined;
  subscription: SubscriptionStatusResponse | null = null;
  hasActiveSubscription: boolean = false;
  isCompanyOwner: boolean = false;

  // Computed signal that tracks the layout service's profile sidebar visibility
  visible = computed(() => this.layoutService.profileSidebarVisible());

  constructor(
    public layoutService: LayoutService,
    private store: Store,
    private toastService: ToastServiceService,
    public layout: LayoutService,
    public avatarService: AvatarService,
    private router: Router
  ) {}

  ngOnInit() {
    this.store.select(selectProfile).subscribe((profile: ProfileInfoDto | null) => {
      this.avatarBase64 = this.avatarService.processAvatar(profile?.avatar);
      this.profile = profile;
      // Check if user is company owner
      this.isCompanyOwner = profile?.groups?.includes('COMPANY_OWNER') || false;
    });

    // Subscribe to subscription status
    this.store.select(selectSubscription).subscribe((sub) => {
      this.subscription = sub;
    });

    // Subscribe to has active subscription
    this.store.select(selectHasValidSubscription).subscribe((hasActive) => {
      this.hasActiveSubscription = hasActive;
    });
  }

  signOut() {
    this.store.dispatch(logout());
    this.router.navigate(['/auth/login']);
    this.layoutService.hideProfileSidebar();
  }

  navigateToSubscription() {
    this.router.navigate(['/subscription']);
    this.layoutService.hideProfileSidebar();
  }
}
